// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_o8-0";